import React from 'react';
export function WhoThisIsForSection() {
  return <section className="w-full bg-editorial-bg py-section-mobile md:py-section-desktop px-6 md:px-8 border-t border-editorial-divider bg-gradient-to-b from-editorial-bg to-editorial-bgAlt" data-id="element-147">
      <div className="max-w-3xl mx-auto" data-id="element-148">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-editorial-text mb-12 md:mb-16 text-center" data-id="element-149">
          This investigation is for you if:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-150">
          <div className="flex flex-col items-center text-center" data-id="element-151">
            <span className="text-editorial-accent text-2xl mb-4" data-id="element-152">✦</span>
            <p className="text-lg md:text-xl font-sans text-editorial-text leading-relaxed" data-id="element-153">
              You still believe free speech is worth defending
            </p>
          </div>

          <div className="flex flex-col items-center text-center" data-id="element-154">
            <span className="text-editorial-accent text-2xl mb-4" data-id="element-155">✦</span>
            <p className="text-lg md:text-xl font-sans text-editorial-text leading-relaxed" data-id="element-156">
              You've watched the last three years and felt something was deeply
              wrong
            </p>
          </div>

          <div className="flex flex-col items-center text-center" data-id="element-157">
            <span className="text-editorial-accent text-2xl mb-4" data-id="element-158">✦</span>
            <p className="text-lg md:text-xl font-sans text-editorial-text leading-relaxed" data-id="element-159">
              You want to understand HOW a society reaches the point of no
              return
            </p>
          </div>
        </div>
      </div>
    </section>;
}